import { useCookieConsent as useCookieConsentContext } from '../context/CookieConsentContext';

/**
 * Hook for accessing cookie consent functionality
 * This is a convenience wrapper around useCookieConsent from context
 */
export const useCookieConsent = () => {
  return useCookieConsentContext();
};

